export const KEY_CODES = {
  DELETE: 8,
}
